import { autoinject, bindable, containerless, Disposable } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { GlobalContextService } from '../../components/global-select/global-context-service';

@autoinject
@containerless
export class SelectedCustomerLink {
	@bindable isCurrent = false;
	subscriber: Disposable;
	customerId: string;

	private customerItemName = 'customer';

	constructor(
		private globalContext: GlobalContextService,
		private eventAggregator: EventAggregator) {
	}

	attached() {
		this.customerId = this.globalContext.getId(this.customerItemName);
		this.subscriber = this.eventAggregator.subscribe(`idChanged-${this.customerItemName}`, id => {
			this.customerId = id;
		});
	}
}
